import { Box, useColorModeValue, useTheme } from "@chakra-ui/react";
import { css, Global } from "@emotion/react";
import React from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

type Props = {
  onChange?: (value: Date) => void;
};

const CalendarDatePicker = ({ onChange }: Props) => {
  const theme = useTheme();
  const nowColour = useColorModeValue(
    theme.colors?.lancsBlue?.["200"],
    theme.colors?.whiteAlpha?.["200"]
  );
  const hoverColour = useColorModeValue(
    theme.colors?.lancsBlue?.["300"],
    theme.colors?.whiteAlpha?.["300"]
  );
  const selectedBg = useColorModeValue(
    theme.colors?.lancsBlue?.["500"],
    theme.colors?.lancsBlue?.["300"]
  );
  const selectedFg = useColorModeValue("white", "black");

  return (
    <Box
      css={css`
        .react-calendar {
          width: 100%;
          padding: 0.5em;
          background: transparent;
          border: 0;
          font-family: EffraRegular;

          &__month-view__weekdays__weekday abbr {
            text-decoration: none;
          }

          &__tile--now {
            background: ${nowColour};
          }

          &__tile--now:enabled:hover,
          .react-calendar__tile--now:enabled:focus {
            background: ${hoverColour};
          }

          &__tile:enabled:hover,
          .react-calendar__tile:enabled:focus,
          .react-calendar__navigation button:enabled:hover,
          .react-calendar__navigation button:enabled:focus {
            background: ${hoverColour};
          }

          button {
            transition: 0.1s all;
          }

          &__tile {
            border-radius: 100px;
          }

          &__tile--active,
          .react-calendar__tile--active:enabled:hover,
          .react-calendar__tile--active:enabled:focus {
            background: ${selectedBg};
            color: ${selectedFg};
          }

          &__month-view__days__day--weekend {
            color: inherit;
            opacity: 0.5;
          }
        }
        .react-calendar__tile:disabled {
          background-color: inherit;
          color: darkgrey;
        }
        .react-calendar__tile:disabled:hover {
          cursor: not-allowed;
        }
      `}
    >
      <Calendar onChange={onChange} minDate={new Date()} />
    </Box>
  );
};

export default CalendarDatePicker;
